<template>
  <div class="footer px-2 w-100">
    <span class="float-left">
      <b>©2019 NewCold</b> (Commit: 979e995)
    </span>
    <span class="float-right">
      <img
        src="../../assets/logo-footer.png"
        data-rjs="2"
        style="margin-top:-5px;margin-right:5px;vertical-align: middle;display: inline;"
        width="28"
        height="28"
      />
      <a
        target="_blank"
        style="font-size:16px; color:#161E44;vertical-align: middle;display: inline;"
        href="https://vedicium.com/"
      >
        <b>VeDicium</b>
      </a>
    </span>
  </div>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style>
.footer {
  font-size: 0.8rem;
  position: absolute;
  bottom: 5px;
}

.footer a b {
  font-size: 0.9rem;
}
</style>